var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback } from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import tinycolor from "tinycolor2";
import styled from "styled-components";
import "react-day-picker/lib/style.css";
var formatDate = function (date) {
    return date === null || date === void 0 ? void 0 : date.toLocaleDateString();
};
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n\n  .custom-container {\n    input {\n      width: 100%;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      padding: 12px 12px;\n      line-height: 1em;\n      font-size: 1.4rem;\n      height: 40px;\n      outline: none;\n      color: ", ";\n\n      &:focus {\n        background-color: ", ";\n      }\n    }\n  }\n\n  .custom-overlayWrapper {\n    box-sizing: border-box;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: #ffffff;\n    box-shadow: 0 5px 12px 0 rgba(29, 114, 104, 0.14);\n    display: inline-block;\n  }\n\n  .custom-overlay {\n    .DayPicker-Day--selected {\n      background-color: ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n\n  .custom-container {\n    input {\n      width: 100%;\n      border: 1px solid ", ";\n      border-radius: ", ";\n      padding: 12px 12px;\n      line-height: 1em;\n      font-size: 1.4rem;\n      height: 40px;\n      outline: none;\n      color: ", ";\n\n      &:focus {\n        background-color: ",
    ";\n      }\n    }\n  }\n\n  .custom-overlayWrapper {\n    box-sizing: border-box;\n    border: 1px solid ", ";\n    border-radius: ", ";\n    background-color: #ffffff;\n    box-shadow: 0 5px 12px 0 rgba(29, 114, 104, 0.14);\n    display: inline-block;\n  }\n\n  .custom-overlay {\n    .DayPicker-Day--selected {\n      background-color: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.borderColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
}, function (_a) {
    var theme = _a.theme;
    return tinycolor(theme.gwThemed.inputs.main.color).lighten(45).toString();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.lightBg2;
}, function (_a) {
    var theme = _a.theme;
    return theme.borders.radius;
}, function (_a) {
    var theme = _a.theme;
    return theme.gwThemed.inputs.main.color;
});
var CLASSNAMES = {
    container: "custom-container",
    overlayWrapper: "custom-overlayWrapper",
    overlay: "custom-overlay",
};
export var InputDate = function (_a) {
    var selected = _a.selected, onChange = _a.onChange;
    var handleDayChange = useCallback(function (newVal) {
        onChange(newVal);
    }, [onChange]);
    return (React.createElement(Container, null,
        React.createElement(DayPickerInput, { formatDate: formatDate, value: selected, onDayChange: handleDayChange, classNames: CLASSNAMES, dayPickerProps: { selectedDays: selected } })));
};
var templateObject_1;
//# sourceMappingURL=InputDate.js.map